import { createFileRoute } from '@tanstack/react-router'
import { UmbrellaTerms } from '@/components/umbrella/Legal'

export const Route = createFileRoute('/terms')({
  component: UmbrellaTerms,
})
